"use strict";

import {Rule,ValidationRule} from './rule.js';

class Vuelidator {
    /**
     * 
     * {
     *  name: 'required|min:2',
     *  description: ['nullable','min:2']
     *  email: [Rule.required(), Rule.email()],
     * }
     * @param {Object} rules 
     */
    constructor(rules) {
        this._rules = {};

        if (rules) {
            for (let ruleName in rules) {
                this.setRules(ruleName, rules[ruleName]);
            }
        }

        // Proxy for rules object
        this.rules = new Proxy(this._rules, {
            get(allRules, fieldName, receiver) {
                return this.getRule(fieldName, rules);
            }
        });
    }

    getRule(fieldName) {
        const rules = this._rules[fieldName] !== undefined ? this._rules[fieldName] : [];
        return Vuelidator.parseFieldRules(fieldName, rules);
    }
    setRules(fieldName, rules) {
        if (typeof rules === "string") {
            rules = rules.split("|");
        }
        this._rules[fieldName] = rules;
        return this;
    }
    addRule(fieldName, rule) {
        if (this._rules[fieldName] === undefined)
            this._rules[fieldName] = [];
        this._rules[fieldName].push(rule);
        return this;
    }

    getRules() {
        let rules = {};
        for (let fieldName in this._rules) {
            rules[fieldName] = this.getRule(fieldName);
        }
        return rules;
    }

    clearRules(fieldName) {
        delete this._rules[fieldName];
        return this;
    }

    /**
     * 
     * @param {string} field Field name to be validated
     * @param {array|string} rules Rules to be parsed as string or array (ex.: ["required", "numeric", "min:2"] or 'required"|numeric|min:2' )
     * @returns {function[]} An array of validation functions (to be used in Vuetify rules)
     */
    static parseFieldRules(fieldName, rules) {
        if (typeof rules === "string") {
            rules = rules.split("|");
        }

        let validations = [];


        let type = null;
        let ruleOpt = {
            skipNextRules: false,
        };
        for (let r of rules) {
            let rule = null;

            if (r instanceof ValidationRule) {
                rule = r;
            }
            else if (typeof r === 'function') {
                r = Rule.closure(r);
            }
            else {
                let ruleName = null;
                let args = [];
                let a = r.split(":");
                // get fn name before :
                ruleName = a.shift();
                ///get arguments after : and splitted with , ; map 'null' to proper null value
                args = a.length > 0 ? a.join(":").split(",").map(v => v === 'null' ? null : v) : [];

                /// Convert string to ValidationRule ///
                if (Rules[ruleName] !== undefined) {
                    rule = Rules[ruleName](...args);
                } else {
                    console.warn(`Vuelidator parse error: Rule '${ruleName}' does not exist!`);
                }

            }

            if (rule !== null) {
                /// If rule sets a type save it for future use ///
                if (rule.type !== undefined) {
                    type = rule.type;
                }
                /// Convert to validation function ///
                validations.push(
                    r.toFunction(fieldName, type, ruleOpt)
                );
            }
        }

        return validations;
    }

}

export { Vuelidator, Rule };